import React from 'react'
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function About() {
  return (
    <div className='h-screen '>
      <Navbar/>
        <div className='bg-black text-white text-center px-24 py-20 border-yellow-100'>
            <h1 className='font-bold underline text-2xl pb-5'>ABOUT-US</h1>
            <p>After two years on the market, our platform has been specifically dedicated to innovating Music NFTs, looking towards the future. We are among the top Music NFT platforms worldwide.</p>
        </div>
      <Footer/>
    </div>
  )
}

export default About;